<template>
  <div id="app" class="page-all">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  background: rgba(240, 240, 240, 1);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  zoom: 1;
}
p{
  margin-block-start: 0;
  margin-block-end: 0;
}
.page-all {
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue